import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  normalize(json) {
    const { relationships } = json.data;
    if (relationships['company']) {
      delete relationships['company'];
    }
    return json;
  },
});
